import _regeneratorValues from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import "core-js/modules/web.dom.iterable";
import _regenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.find-index";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    separator: {
      type: String,
      default: '/'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    width: {
      type: String,
      default: '400px'
    },
    filterable: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    suggestionsPopperClass: {
      type: String,
      default: 'suggestions-popper-class'
    },
    searchWidth: {
      type: String
    },
    searchEmptyText: {
      type: String,
      default: '暂无数据'
    }
  },
  data: function data() {
    return {
      isSearchEmpty: false,
      keyword: '',
      options: [],
      current: [],
      labelObject: {
        label: [],
        value: []
      },
      labelArray: [],
      currentProps: {
        multiple: this.props.multiple,
        checkStrictly: this.props.checkStrictly,
        value: this.props.value,
        label: this.props.label,
        leaf: this.props.leaf,
        lazy: true,
        lazyLoad: this.lazyLoad
      }
    };
  },
  computed: {
    placeholderVisible: function placeholderVisible() {
      if (this.current) {
        return this.current.length === 0;
      } else {
        return true;
      }
    }
  },
  watch: {
    current: function current() {
      this.getLabelArray();
    },
    value: function value(v) {
      this.current = v;
    },
    keyword: function keyword() {
      this.isSearchEmpty = false;
    }
  },
  created: function created() {
    this.initOptions();
  },
  methods: {
    // 搜索是否选中
    isChecked: function isChecked(value) {
      // 多选
      if (this.props.multiple) {
        var index = this.current.findIndex(function (item) {
          return item.join() === value.join();
        });
        if (index > -1) {
          return 'el-link el-link--primary';
        } else {
          return '';
        }
      } else {
        if (value.join() === this.current.join()) {
          return 'el-link el-link--primary';
        } else {
          return '';
        }
      }
    },
    // 搜索
    querySearch: function querySearch(query, callback) {
      var _this = this;
      this.props.lazySearch(query, function (list) {
        callback(list);
        if (!list || !list.length) _this.isSearchEmpty = true;
      });
    },
    // 选中搜索下拉搜索项
    handleSelect: function handleSelect(item) {
      var _this2 = this;
      if (this.props.multiple) {
        var index = this.current.findIndex(function (obj) {
          return obj.join() === item[_this2.props.value].join();
        });
        if (index === -1) {
          this.$refs.panel.clearCheckedNodes();
          this.current.push(item[this.props.value]);
          this.$emit('change', this.current);
        }
      } else {
        // 选中下拉选变更值
        if (this.current === null || item[this.props.value].join() !== this.current.join()) {
          this.$refs.panel.activePath = [];
          this.current = item[this.props.value];
          this.$emit('change', this.current);
        }
      }
      this.keyword = '';
    },
    // 初始化数据
    initOptions: function () {
      var _initOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this3 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.props.lazyLoad(0, function (list) {
                _this3.$set(_this3, 'options', list);
                if (_this3.props.multiple) {
                  _this3.current = _toConsumableArray(_this3.value);
                } else {
                  _this3.current = _this3.value;
                }
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initOptions() {
        return _initOptions.apply(this, arguments);
      }
      return initOptions;
    }(),
    getLabelArray: function () {
      var _getLabelArray = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this4 = this;
        var array, i, obj;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.props.multiple) {
                _context2.n = 5;
                break;
              }
              array = [];
              i = 0;
            case 1:
              if (!(i < this.current.length)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 2;
              return this.getObject(this.current[i]);
            case 2:
              obj = _context2.v;
              array.push(obj);
            case 3:
              i++;
              _context2.n = 1;
              break;
            case 4:
              this.labelArray = array;
              this.$emit('input', this.current);
              if (!this.disabled) {
                this.$nextTick(function () {
                  _this4.$refs.popover.updatePopper();
                });
              }
              _context2.n = 7;
              break;
            case 5:
              _context2.n = 6;
              return this.getObject(this.current || []);
            case 6:
              this.labelObject = _context2.v;
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getLabelArray() {
        return _getLabelArray.apply(this, arguments);
      }
      return getLabelArray;
    }(),
    /** 格式化id=>object */getObject: function () {
      var _getObject = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        var _this5 = this;
        var options, nameArray, _loop, i, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              options = this.options;
              nameArray = [];
              _loop = /*#__PURE__*/_regenerator().m(function _loop(i) {
                var index, list, _t, _t2;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      index = options.findIndex(function (item) {
                        return item[_this5.props.value] === id[i];
                      });
                      if (!(index < 0)) {
                        _context3.n = 1;
                        break;
                      }
                      return _context3.a(2, 1);
                    case 1:
                      nameArray.push(options[index][_this5.props.label]);
                      if (!(i < id.length - 1 && options[index].children === undefined)) {
                        _context3.n = 3;
                        break;
                      }
                      list = new Promise(function (resolve) {
                        _this5.props.lazyLoad(id[i], function (list) {
                          resolve(list);
                        });
                      });
                      _t = _this5;
                      _t2 = options[index];
                      _context3.n = 2;
                      return list;
                    case 2:
                      _t.$set.call(_t, _t2, 'children', _context3.v);
                      options = options[index].children;
                      _context3.n = 4;
                      break;
                    case 3:
                      options = options[index].children;
                    case 4:
                      return _context3.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 1:
              if (!(i < id.length)) {
                _context4.n = 4;
                break;
              }
              return _context4.d(_regeneratorValues(_loop(i)), 2);
            case 2:
              if (!_context4.v) {
                _context4.n = 3;
                break;
              }
              return _context4.a(3, 3);
            case 3:
              i++;
              _context4.n = 1;
              break;
            case 4:
              return _context4.a(2, {
                value: id,
                label: nameArray
              });
            case 5:
              _context4.p = 5;
              _t3 = _context4.v;
              this.current = [];
              return _context4.a(2, {
                value: [],
                label: []
              });
          }
        }, _callee3, this, [[0, 5]]);
      }));
      function getObject(_x) {
        return _getObject.apply(this, arguments);
      }
      return getObject;
    }(),
    // 懒加载数据
    lazyLoad: function () {
      var _lazyLoad = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(node, resolve) {
        var _this6 = this;
        var current;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              current = this.current;
              if (this.props.multiple) {
                current = _toConsumableArray(this.current);
              }
              if (node.root) {
                resolve();
              } else if (node.data[this.props.leaf]) {
                resolve();
              } else if (node.data.children) {
                if (this.props.multiple) {
                  this.current = current;
                }
                resolve();
              } else {
                this.props.lazyLoad(node.value, function (list) {
                  node.data.children = list;
                  if (_this6.props.multiple) {
                    _this6.current = current;
                  }
                  resolve(list);
                });
              }
            case 1:
              return _context5.a(2);
          }
        }, _callee4, this);
      }));
      function lazyLoad(_x2, _x3) {
        return _lazyLoad.apply(this, arguments);
      }
      return lazyLoad;
    }(),
    // 删除多选值
    /** 删除**/
    handleClose: function handleClose(item) {
      var index = this.current.findIndex(function (obj) {
        return obj.join() === item.value.join();
      });
      if (index > -1) {
        this.$refs.panel.clearCheckedNodes();
        this.current.splice(index, 1);
        this.$emit('change', this.current);
      }
    },
    // 点击清空按钮
    clearBtnClick: function clearBtnClick() {
      this.$refs.panel.clearCheckedNodes();
      this.current = [];
      this.$emit('change', this.current);
    },
    changeCurrent: function changeCurrent() {
      this.$emit('change', this.current);
    }
  }
};